import { IValue } from './ivalue';
import { ControlType } from '../controltype';
import { EventEmitter } from '@angular/core';

export class TextValue implements IValue {
    value: string;
    clear$ = new EventEmitter();
    constructor(data: string = '') {
        this.value = data;
    }
    getControlType(): ControlType {
        return ControlType.Text;
    }
    clearValue(): void {
        this.value = undefined;
        this.clear$.emit();
    }
    setOriginalValue(value: any): void {
        throw new Error('Method not implemented.');
    }
    getOriginalValue() {
        return this.value;
    }
    isEmpty(): boolean {
        return !this.value;
    }
}
